/**
 * CalGreenWordmark — hero-only stylised replica of the CALGreen brand logo.
 *
 * Typography:
 *   - "CAL"   → Permanent Marker (upright brush script, Google Fonts)
 *   - "Green" → inherits display sans-serif (Cabinet Grotesk), bold
 *   - Colour  → CALGreen brand green (#009944)
 *   - Underline → hand-drawn SVG brush-stroke arc, tapering to a flick
 *
 * Intended for use INSIDE an H1 as a replacement for the word "CALGreen".
 * The wrapper uses inline-block so it sits cleanly on the headline baseline.
 */
const CAL_GREEN = "#009944";

const CalGreenWordmark = ({ className = "", withPeriod = false }) => (
  <span
    className={`cal-green-wordmark inline-block relative leading-none align-baseline ${className}`}
    style={{ color: CAL_GREEN }}
    data-testid="cal-green-wordmark"
  >
    <span
      style={{
        fontFamily: "'Permanent Marker', 'Caveat', cursive",
        fontWeight: 400,
        letterSpacing: "-0.02em",
        fontSize: "0.98em",
        // Nudge down slightly so the script rides the baseline like the real logo
        display: "inline-block",
        transform: "translateY(0.02em)",
      }}
    >
      CAL
    </span>
    <span
      className="font-display"
      style={{
        fontWeight: 900,
        letterSpacing: "-0.02em",
        marginLeft: "0.02em",
      }}
    >
      Green
    </span>
    {withPeriod && (
      <span
        className="font-display"
        style={{ fontWeight: 900, letterSpacing: "-0.02em" }}
      >
        .
      </span>
    )}
  </span>
);

export default CalGreenWordmark;
